import { render, staticRenderFns } from "./AppNavbar.vue?vue&type=template&id=328f1a5e&scoped=true&"
import script from "./AppNavbar.vue?vue&type=script&lang=ts&"
export * from "./AppNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./AppNavbar.vue?vue&type=style&index=0&id=328f1a5e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f1a5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
